/* ==========================================================================
   PanelRoom > Client > Children > Utils
   ========================================================================== */
/**
 * has Ages
 * @param {Object} instance
 * @param {Number} index index of array persons
 * @returns {boolean}
 */
function hasAges(instance, index) {
    const { config = {} } = instance;
    const { people: peopleConfig = [] } = config;

    return !!peopleConfig[index] && !!peopleConfig[index].options && peopleConfig[index].options.length > 0;
}

/* Exports */
module.exports = {
    hasAges
};
